export default __webpack_public_path__ + "static/media/GR00024_2-cup_disciple.e1762a1f.svg";